export enum UserType {
  CONSULTANT = 'CONSULTANT',
  GUEST = 'GUEST',
  PATIENT = 'PATIENT',
}
